export default {
	'DOMAIN': process.env.ROUTERSOFT_API_DOMAIN === "undefined" ? 'routeryuncs.com' : process.env.ROUTERSOFT_DOMAIN,
    'API_DOMAIN': process.env.ROUTERSOFT_API_DOMAIN === "undefined" ? 'https://mp.rmt.test.routeryuncs.com' : process.env.ROUTERSOFT_API_DOMAIN,
    'OSS_DOMAIN': process.env.ROUTERSOFT_OSS_DOMAIN === "undefined" ? 'https://mcp.api.test.routeryuncs.com' : process.env.ROUTERSOFT_OSS_DOMAIN,
    'BUILD_CODE': process.env.ROUTERSOFT_BUILDCODE === "undefined" ? '' : process.env.ROUTERSOFT_BUILDCODE
};


// export default {
//     'DOMAIN': 'routeryuncs.com',
//     'API_DOMAIN': 'http://mp.rmt.test.routeryuncs.com',
//     'OSS_DOMAIN': 'http://mcp.api.test.routeryuncs.com',
//     'BUILD_CODE': ''
// };

// export default {
//     'DOMAIN': 'localhost',
//     'API_DOMAIN': 'http://localhost:8888',
//     'OSS_DOMAIN': 'http://mcp.api.test.routeryuncs.com',
//     'BUILD_CODE': ''
// };


// WEBPACK FOOTER //
// ./src/config/common.conf.js